import * as React from 'react';
import styled from 'styled-components';
import {
  color,
  ColorProps,
  compose,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';

export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M12 14.632a3.154 3.154 0 003.158-3.158V5.158A3.154 3.154 0 0012 2a3.154 3.154 0 00-3.158 3.158v6.316A3.154 3.154 0 0012 14.632zm6.221-3.158a1.05 1.05 0 00-1.032.894c-.431 2.474-2.589 4.369-5.189 4.369s-4.758-1.895-5.19-4.369a1.05 1.05 0 00-1.031-.894c-.642 0-1.147.568-1.053 1.2a7.36 7.36 0 006.221 6.084v2.19c0 .578.474 1.052 1.053 1.052s1.053-.474 1.053-1.053v-2.19a7.36 7.36 0 006.22-6.083c.106-.632-.41-1.2-1.052-1.2z"
      />
    </svg>
  );
});
export const IconSystemV2MediaTestMic = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
